import { useState, useEffect, useMemo } from 'react';
import ModalDelete from '../../../../components/Shared/modal/delete';
import ModalConfirm from '../../../../components/Shared/modal/confirm';
import { useTranslation } from 'react-i18next';
import IconWaring from '../../../../assets/Images/icons/icon-waring';
import { Dropdown, Menu, Tabs } from 'antd';
import { useMetadataContext } from '../../MetadataContext';
import { useNavigate } from 'react-router-dom';
import { ROUTER } from '../../../../constants/router';
import useQuery from '../../../../util/useQuery';
import RelatedEntities from './RelatedEntities';
import RelatedActivities from './RelatedActivities';
import ModalRename from '../ModalRename';
import ModalMove from './ModalMove';

const { TabPane } = Tabs;

export default function SubDetail() {
    const UIContext = useMetadataContext();
    const UIProps = useMemo(() => {
        return {
            key: UIContext.key,
            setKey: UIContext.setKey,
        };
    }, [UIContext]);
    const { setKey } = UIProps;

    const { t, i18n } = useTranslation(['metadata']);
    const params = useQuery();
    const navigate = useNavigate();
    const lang = i18n?.language;
    // Result Data
    const [entities, setEntities] = useState();
    const [activities, setActivities] = useState();
    // Delete Sub Detail
    const [loading, setLoading] = useState(false);
    const [loadingDelete] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [openRename, setOpenRename] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [openMove, setOpenMove] = useState(false);

    const menu = () => (
        <Menu
            items={[
                {
                    label: (
                        <div
                            className="w-[100px] cursor-pointer flex"
                            onClick={() => {
                                // setApplicationData(item);
                                setOpenMove(true);
                            }}
                        >
                            {t('Move')}
                        </div>
                    ),
                },
                {
                    label: (
                        <a
                            className="w-[100px] cursor-pointer flex"
                            onClick={() => {
                                setConfirmDelete(true);
                                // setDataObject(item);
                            }}
                        >
                            {t('common.Delete')}
                        </a>
                    ),
                },
            ]}
        />
    );

    // Get Entities
    const getEntities = async (id) => {
        setEntities([
            {
                id: 1,
                entityName: 'Dataset',
                entityGroup: 'Glue',
                entityData: [
                    {
                        id: 1,
                        data: 'motor.mt_stkdetail',
                    },
                ],
            },
            {
                id: 2,
                entityName: 'Table',
                entityGroup: 'Glue',
                entityData: [
                    {
                        id: 1,
                        data: 'motor.mt_transferstk',
                    },
                    {
                        id: 2,
                        data: 'mt_transferstk',
                    },
                    {
                        id: 3,
                        data: 'motor',
                    },
                ],
            },
        ]);
    };

    // Get Activities
    const getActivities = async (id) => {
        setActivities([
            {
                id: 1,
                activityName: 'รับสมัครงานระบบมหาวิทยาลัย Online 01',
                department: 'Admin',
            },
            {
                id: 2,
                activityName: 'รับสมัครงานระบบมหาวิทยาลัย Online 02',
                department: 'IT Support',
            },
            {
                id: 3,
                activityName: 'รับสมัครงานระบบมหาวิทยาลัย Online 03',
                department: 'HR',
            },
        ]);
    };

    useEffect(() => {
        getActivities(1);
        getEntities(1);
    }, []);

    return (
        <>
            <div className="p-8 bg-white rounded-md">
                <div className="flex justify-between">
                    <div className="flex flex-col">
                        <div className="flex items-center">
                            <span className="pr-2 font-semibold text-xl text-[#7B67FB]">
                                Barcode พ.ร.บ.{' '}
                            </span>
                            <span
                                className="pr-2 cursor-pointer"
                                onClick={() => {
                                    setOpenRename(true);
                                }}
                                style={{ height: 30 }}
                            >
                                {IconEdit}
                            </span>
                        </div>
                        <div className="font-semibold text-xs text-left text-[#65707A]">
                            Personal Data
                        </div>
                    </div>
                    <div>
                        <Dropdown overlay={menu()} placement="bottomRight">
                            {IconDetail}
                        </Dropdown>
                    </div>
                </div>
                <div
                    className="my-3"
                    style={{ borderBottom: '1px solid #DEDEE3' }}
                ></div>
                <Tabs
                    onChange={(key) => {
                        setKey(key);
                        navigate(`${ROUTER.DATA_CATALOG.METADATA}?tab=${key}`);
                    }}
                    activeKey={params.get('tab') || '1'}
                >
                    <TabPane tab={t('Related Entities')} key={1}>
                        <RelatedEntities entities={entities} />
                    </TabPane>
                    <TabPane tab={t('Related Activity')} key={2}>
                        <RelatedActivities activites={activities} />
                    </TabPane>
                </Tabs>
            </div>

            <ModalDelete
                loading={loadingDelete}
                open={openDelete}
                title={lang === 'en' ? 'Confirm delete?' : 'ยืนยันการลบข้อมูล?'}
                text={
                    lang === 'en'
                        ? `Metadata to be deleted is {{"Barcode พ.ร.บ."}}`
                        : `Metadata ที่ต้องการลบ คือ {{"Barcode พ.ร.บ."}}`
                }
                handelOk={async () => {
                    console.log('ok');
                }}
                handelClose={() => {
                    setOpenDelete(false);
                    setLoading(false);
                }}
            />
            <ModalConfirm
                loading={loading}
                open={confirmDelete}
                title={
                    lang === 'en'
                        ? 'Precautions before deleting'
                        : 'ข้อควรระวังก่อนลบ'
                }
                text={
                    lang === 'en'
                        ? `If this metadata is used in connection with Data Flow, RoPA, Privacy Policy, Data Source data, its deletion will affect all such data.`
                        : `หากมีการใช้ metadata นี้ผูกกับข้อมูลของ  \nData Flow, RoPA, Privacy Policy, Data Source อยู่ \nการลบนี้จะมีผลกระทบต่อข้อมูลดังกล่าวทั้งหมด`
                }
                confirmText={t('ดำเนินการต่อ')}
                handelOk={() => {
                    setConfirmDelete(false);
                    setOpenDelete(true);
                }}
                handelClose={() => {
                    setConfirmDelete(false);
                    setLoading(false);
                }}
                icon={<IconWaring />}
            />
            <ModalRename
                open={openRename}
                handelClose={() => setOpenRename(false)}
                data={{ name: 'Personal Data' }}
            />
            <ModalMove open={openMove} handelClose={() => setOpenMove(false)} />
        </>
    );
}

const IconEdit = (
    <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width="32" height="32" rx="6" fill="#F3F6F9" />
        <path
            d="M20.6587 9.34131L22.6587 11.3413L21.134 12.8666L19.134 10.8666L20.6587 9.34131ZM13.3334 18.6666H15.3334L20.1914 13.8086L18.1914 11.8086L13.3334 16.6666V18.6666Z"
            fill="#7B67FB"
        />
        <path
            d="M20.6667 20.6667H13.4387C13.4213 20.6667 13.4033 20.6733 13.386 20.6733C13.364 20.6733 13.342 20.6673 13.3193 20.6667H11.3333V11.3333H15.898L17.2313 10H11.3333C10.598 10 10 10.5973 10 11.3333V20.6667C10 21.4027 10.598 22 11.3333 22H20.6667C21.0203 22 21.3594 21.8595 21.6095 21.6095C21.8595 21.3594 22 21.0203 22 20.6667V14.888L20.6667 16.2213V20.6667Z"
            fill="#7B67FB"
        />
    </svg>
);

const IconDetail = (
    <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width="32" height="32" rx="6" fill="#F5F6FF" />
        <path
            d="M18.5156 15C18.5156 15.9668 19.3066 16.7578 20.2734 16.7578C21.2402 16.7578 22.0312 15.9668 22.0312 15C22.0312 14.0332 21.2402 13.2422 20.2734 13.2422C19.3066 13.2422 18.5156 14.0332 18.5156 15Z"
            fill="#7B67FB"
        />
        <path
            d="M16.7578 15C16.7578 14.0332 15.9668 13.2422 15 13.2422C14.0332 13.2422 13.2422 14.0332 13.2422 15C13.2422 15.9668 14.0332 16.7578 15 16.7578C15.9668 16.7578 16.7578 15.9668 16.7578 15Z"
            fill="#7B67FB"
        />
        <path
            d="M11.4844 15C11.4844 14.0332 10.6934 13.2422 9.72656 13.2422C8.75977 13.2422 7.96875 14.0332 7.96875 15C7.96875 15.9668 8.75977 16.7578 9.72656 16.7578C10.6934 16.7578 11.4844 15.9668 11.4844 15Z"
            fill="#7B67FB"
        />
    </svg>
);
